module.exports = __webpack_public_path__ + "static/media/addLogo.d3021c55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/addLogo.svg
// module id = 473
// module chunks = 0